import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as TreeSearchActions from "./actions";
import type { ITreeSearchReducerState } from "./types";

export type TreeSearchAction = ActionType<typeof TreeSearchActions>;

const initialState: ITreeSearchReducerState = {
  materialsUrl: null!,
  materialsQuery: { id: null!, offset: 0, limit: 25, where: {} },
  materialsResult: null!,
  hasError: null!,
  isFetching: null!,
  advancedPOSTLoading: null!
};

// TODO: persist page size

export default function partTreeSearchReducer(state: ITreeSearchReducerState = initialState, action: TreeSearchAction): ITreeSearchReducerState {
  switch (action.type) {
    case getType(TreeSearchActions.initSearch): {
      const { advancedPOSTLoading } = action.payload;
      return {
        ...initialState,
        advancedPOSTLoading: advancedPOSTLoading!
      };
    }

    case getType(TreeSearchActions.fetchResultsStart): {
      const { url, query } = action.payload;
      return {
        ...state,
        materialsUrl: url,
        materialsQuery: query,
        isFetching: true,
        hasError: false
      };
    }

    case getType(TreeSearchActions.fetchResultsFail): {
      return {
        ...state,
        isFetching: false,
        materialsResult: {
          ...state.materialsResult,
          data: [],
          count: 0
        },
        hasError: true
      };
    }

    case getType(TreeSearchActions.fetchResultsSuccess): {
      const { result } = action.payload;
      return {
        ...state,
        materialsResult: result,
        isFetching: false,
        hasError: false
      };
    }

    default:
      return state;
  }
}
